import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=17d5281b&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=17d5281b&prod&lang=css"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=17d5281b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d5281b",
  null
  
)

export default component.exports